import { RouterConfiguration, Router } from 'aurelia-router';
import { bindable, autoinject, observable, computedFrom, singleton } from 'aurelia-framework';
import { SessionData } from '_models/session-data';
import * as Dto from '_models/dtos';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogService } from 'aurelia-dialog';
import { ConfirmDialog } from '_controls/confirm-dialog';

@singleton()
@autoinject
export class RegionsDdl {

    constructor(
        private _eventBus: EventAggregator,
        public sd: SessionData,
        public dialogSvc: DialogService
    ) {
    }

    attached() {
        this.loadRegions();
    }

    @bindable isDialog = false;

    regions: Dto.Region[] = [];
    
    loadRegions() {
        var usa = new Dto.Region();
        var canada = new Dto.Region();
        var cali = new Dto.Region();

        usa.name = 'UNITED STATES';
        usa.type = 'USAIntl';
        canada.name = 'CANADA';
        canada.type = 'Canada';
        cali.name = 'CALIFORNIA';
        cali.type = 'California';

        this.regions = [usa, canada, cali];
    }

    regionSelected(region: Dto.Region) {

        this.confirmContinue().then(confirmed => {
            if (confirmed) {
                this.sd.resetWizard();
                this.sd.region = region;
                this.sd.save();
                this._eventBus.publish('region-changed', region.type);
            }            
        }); 
    }

    confirmContinue() {

        var isProductSelected = this.sd.wizard.selectedProduct != null;

        if (isProductSelected) {
            // Confirm if the user really wants to change products... warn of wizard reset
            return this.dialogSvc.open({
                viewModel: ConfirmDialog,
                model: 'Changing the region will remove your existing product and color selections.  Are you sure you want to continue?'
            }).whenClosed(e => !e.wasCancelled);
        } else {
            // Signal that it is ok to continue
            return Promise.resolve<boolean>(true);
        }
    }
}